import { keyBy } from '../../helpers/common'

export const convertDataTree = (data, idKey, parentIdKey) => {
  const byId = keyBy(
    data.map((item) => {
      return { ...item, children: {} }
    }),
    idKey,
  )
  data.forEach((item) => {
    if (item[parentIdKey] && byId[item[parentIdKey]]) {
      byId[item[parentIdKey]].children[item[idKey]] = byId[item[idKey]]
    }
  })
  data.forEach((item) => {
    if (item && item[parentIdKey] && item[parentIdKey] !== item[idKey]) {
      delete byId[item[idKey]]
    }
  })
  return byId
}

export const pushChildren = (item, callback, isIncludeParent) => {
  const childrenKeys = Object.keys(item.children)
  if (childrenKeys.length > 0) {
    if (isIncludeParent) {
      callback(item)
    }
    childrenKeys.forEach((key) => {
      pushChildren(item.children[key], callback, isIncludeParent)
    })
  } else {
    callback(item)
  }
}

export const getAllChildrenItem = (item, isIncludeParent = false) => {
  const ids = []
  pushChildren(item, (item) => ids.push(item), isIncludeParent)
  return ids
}

export const pushIdChildren = (item, idKey, callback, exceptChildren) => {
  if (item?.children) {
    const childrenKeys = Object.keys(item.children)
    if (childrenKeys.length > 0) {
      childrenKeys.forEach((key) => {
        pushIdChildren(item.children[key], idKey, callback, exceptChildren)
      })
    } else if (!exceptChildren || !exceptChildren?.includes(item[idKey])) {
      callback(item[idKey])
    }
  }
}

export const getAllIdTree = (treeData, idKey) => {
  const ids = []
  Object.keys(treeData).forEach((key) =>
    pushIdChildren(treeData[key], idKey, (item) => ids.push(item)),
  )
  return ids
}

export const getAllIdItem = (item, idKey, exceptChildren) => {
  const ids = []
  pushIdChildren(item, idKey, (item) => ids.push(item), exceptChildren)
  return ids
}

export const pushIdIncludeParent = (item, idKey, callback) => {
  const childrenKeys = Object.keys(item.children)
  callback(item[idKey])
  if (childrenKeys.length > 0) {
    childrenKeys.forEach((key) => {
      pushIdIncludeParent(item.children[key], idKey, callback)
    })
  }
}

export const getAllIdTreeIncludeParent = (treeData, idKey) => {
  const ids = []
  Object.keys(treeData).forEach((key) =>
    pushIdIncludeParent(treeData[key], idKey, (item) => ids.push(item)),
  )
  return ids
}

export const pushParentChecked = (item, idKey, checked, callback) => {
  const idsChildren = []
  pushIdChildren(
    item,
    idKey,
    (item) => idsChildren.push(item),
    item.exceptChildren,
  )
  if (idsChildren.every((id) => checked.includes(id))) {
    callback(item[idKey])
  } else if (Object.keys(item.children).length > 0) {
    Object.keys(item.children).forEach((key) =>
      pushParentChecked(item.children[key], idKey, checked, callback),
    )
  }
}

export const getAllParentChecked = (treeData, idKey, checked) => {
  const idsParent = []
  Object.keys(treeData).forEach((key) =>
    pushParentChecked(treeData[key], idKey, checked, (item) =>
      idsParent.push(item),
    ),
  )
  return idsParent
}

export const getAllIdChecked = (treeData, idKey, listParentChecked = []) => {
  const ids = []
  const recursive = (tree) => {
    Object.keys(tree).forEach((key) => {
      if (listParentChecked.includes(tree[key][idKey])) {
        ids.push(tree[key][idKey])
        ids.push(...getAllIdTreeIncludeParent(tree[key].children, idKey))
      } else {
        if (Object.keys(tree[key].children).length) {
          recursive(tree[key].children)
        }
      }
    })
  }
  recursive(treeData)
  return ids
}

export const getAllIdChildren = (item, idKey) => {
  const ids = []
  const recursive = (children) => {
    Object.keys(children).forEach((key) => {
      ids.push(children[key][idKey])
      if (Object.keys(children[key].children).length) {
        recursive(children[key].children)
      }
    })
  }
  recursive(item.children)
  return ids
}

const deleteDisplayItem = (item, callback) => {
  callback()
  Object.keys(item.children).forEach((key) => {
    deleteDisplayItem(item.children[key], () => {
      delete item.children[key].isDisplay
      delete item.children[key].isOpen
    })
  })
}

const displayItem = (item, callback) => {
  callback()
  Object.keys(item.children).forEach((key) => {
    displayItem(item.children[key], () => {
      item.children[key].isDisplay = true
      delete item.children[key].isOpen
    })
  })
}

export const handleName = (item, nameKey, levelKey) => {
  if (typeof nameKey === 'string') {
    return (
      item[nameKey] +
      `${levelKey && item[levelKey] ? ` L${item[levelKey]}` : ''}`
    )
  } else {
    let nameItem
    for (let i = 0; i < nameKey.length; i++) {
      if (item[nameKey[i]]) {
        nameItem = item[nameKey[i]]
        break
      }
    }
    return (
      nameItem + `${levelKey && item[levelKey] ? ` L${item[levelKey]}` : ''}`
    )
  }
}

const checkItemSearch = ({
  item,
  valueSearch,
  nameKey,
  isSearchAbsolute,
  additionSearchKeys = [],
}) => {
  if (!valueSearch) return false

  const name = handleName(item, nameKey)
  const dataSearch = [
    name,
    ...additionSearchKeys.map((key) => item[key]?.toString()),
  ]

  if (isSearchAbsolute) {
    return dataSearch.some(
      (data) => data.toUpperCase() === valueSearch.toUpperCase(),
    )
  } else {
    return dataSearch.some((data) =>
      data.toUpperCase().includes(valueSearch.toUpperCase()),
    )
  }
}

const checkItem = (
  { item, nameKey, valueSearch, isSearchAbsolute, additionSearchKeys },
  callback,
) => {
  const isActive = checkItemSearch({
    item,
    valueSearch,
    nameKey,
    isSearchAbsolute,
    additionSearchKeys,
  })
  if (isActive) {
    item.isDisplay = true
    callback()
    displayItem(item, () => {
      item.isDisplay = true
      delete item.isOpen
    })
  }
  const keysChildren = Object.keys(item.children)
  if (keysChildren.length > 0) {
    keysChildren.forEach((key) => {
      checkItem(
        {
          item: item.children[key],
          nameKey,
          valueSearch,
          isSearchAbsolute,
          additionSearchKeys,
        },
        () => {
          callback()
          item.isDisplay = true
          item.isOpen = true
        },
      )
    })
  }
}

export const filterTreeData = (
  treeData,
  nameKey,
  valueSearch,
  isSearchAbsolute,
  defaultOpenLevel1,
  additionSearchKeys,
) => {
  const newTreeData = JSON.parse(JSON.stringify(treeData))
  const keys = Object.keys(newTreeData)
  if (!valueSearch.trim()) {
    keys.forEach((key) => {
      if (defaultOpenLevel1) {
        displayItem(newTreeData[key], () => {
          newTreeData[key].isDisplay = true
          newTreeData[key].isOpen = true
        })
      } else {
        displayItem(newTreeData[key], () => {
          newTreeData[key].isDisplay = true
          delete newTreeData[key].isOpen
        })
      }
    })
  } else {
    keys.forEach((key) => {
      deleteDisplayItem(newTreeData[key], () => {
        delete newTreeData[key].isDisplay
        delete newTreeData[key].isOpen
      })
    })
    keys.forEach((key) => {
      checkItem(
        {
          item: newTreeData[key],
          nameKey,
          valueSearch,
          isSearchAbsolute,
          additionSearchKeys,
        },
        () => {
          newTreeData[key].isDisplay = true
          newTreeData[key].isOpen = true
        },
      )
    })
  }
  return newTreeData
}
